/*!
 * KoliBri - The accessible HTML-Standard
 */
import { e as watchBoolean } from './common-D-vggmh2.js';

const validateOpen = (component, value, options) => {
    watchBoolean(component, '_open', value, options);
};

export { validateOpen as v };
//# sourceMappingURL=open-BRQrMgjX.js.map

//# sourceMappingURL=open-BRQrMgjX.js.map